import * as Period from 'constants/Period';

const ICE_HOCKEY_PERIOD_MAP = {};
ICE_HOCKEY_PERIOD_MAP[3000] = Period.NOT_STARTED;
ICE_HOCKEY_PERIOD_MAP[3001] = Period.FIRST;
ICE_HOCKEY_PERIOD_MAP[3002] = Period.FIRST_BREAK;
ICE_HOCKEY_PERIOD_MAP[3003] = Period.SECOND;
ICE_HOCKEY_PERIOD_MAP[3004] = Period.SECOND_BREAK;
ICE_HOCKEY_PERIOD_MAP[3005] = Period.THIRD;
ICE_HOCKEY_PERIOD_MAP[3006] = Period.FULL_TIME;
ICE_HOCKEY_PERIOD_MAP[3007] = Period.OVERTIME;
ICE_HOCKEY_PERIOD_MAP[3008] = Period.OVERTIME_FINISHED;
ICE_HOCKEY_PERIOD_MAP[3009] = Period.PENALTIES;
ICE_HOCKEY_PERIOD_MAP[3010] = Period.FINISHED;

export default ICE_HOCKEY_PERIOD_MAP;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/IceHockey/PeriodMap.js